/**
 * Keep the desktop dropdown panels inside the viewport.
 *
 * A long submenu - Growth Conditions - opens level with its parent item and
 * runs past the bottom of the screen, leaving its tail unreachable without
 * scrolling the page. When a panel opens, lift it just enough for its bottom
 * edge to clear the viewport, never past the top. Only when the panel is
 * taller than the screen itself is it capped and scrolled - the last resort,
 * since there is nowhere left to lift it to.
 *
 * Runs on every panel, so a deep flyout (About us > Who we are > Donations)
 * gets the same treatment when it opens.
 */
(function ($) {
	var MARGIN = 8;

	$(function () {
		var $nav = $('.header-main__nav');

		if (!$nav.length) {
			return;
		}

		function reset(panel) {
			panel.style.marginTop = '';
			panel.style.maxHeight = '';
			panel.style.overflowY = '';
			panel.style.overscrollBehavior = '';
		}

		// Case matters: Foundation triggers "...dropdownMenu", capital M.
		$nav.on('show.zf.dropdownMenu', function (event, $sub) {
			var panel = $sub && $sub[0];

			if (!panel) {
				return;
			}

			reset(panel);

			var room = window.innerHeight - MARGIN;
			var rect = panel.getBoundingClientRect();
			var overflow = rect.bottom - room;

			if (overflow <= 0) {
				return;
			}

			var lift = Math.min(overflow, Math.max(rect.top - MARGIN, 0));

			if (lift > 0) {
				panel.style.marginTop = -lift + 'px';
			}

			if (rect.height > window.innerHeight - 2 * MARGIN) {
				panel.style.maxHeight = (window.innerHeight - 2 * MARGIN) + 'px';
				panel.style.overflowY = 'auto';
				panel.style.overscrollBehavior = 'contain';
			}
		});

		// Closed panels go back to their natural position, so the next open
		// starts from a clean measurement.
		$nav.on('hide.zf.dropdownMenu', function () {
			$nav.find('.is-dropdown-submenu').each(function () {
				reset(this);
			});
		});
	});
})(window.jQuery);
